<template>
  <div class="contract-apply-audit-history-orders-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('contractApplyAuditHistoryOrders.title')" :subtitle="$t('contractApplyAuditHistoryOrders.page.subtitle')" />

    <!-- (3)(4)(6) Toolbar + DataTable + PaginationBar -->
    <div class="ds-panel">
      <ds-toolbar :total="page.total" :density="density" :show-column-setting="false" :show-refresh="true"
        @update:density="density = $event" @refresh="_listAuditOrders(page.current, page.size)">
        <template #left>
          <span class="ds-panel__title">{{ $t('contractApplyAuditHistoryOrders.title') }}</span>
        </template>
      </ds-toolbar>

      <ds-data-table :data="contractApplyAuditOrdersInfo.contractApplyAuditOrders" :loading="loading"
        :error="hasError" :error-message="errorMessage" :density="density" border
        :empty-description="$t('contractApplyAuditHistoryOrders.page.empty')"
        @retry="_listAuditOrders(page.current, page.size)">
        <el-table-column prop="contractCode" :label="$t('contractApplyAuditHistoryOrders.contractCode')" align="center" width="150">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.contractCode || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contractName" :label="$t('contractApplyAuditHistoryOrders.contractName')" align="left" min-width="160" show-overflow-tooltip />
        <el-table-column prop="contractTypeName" :label="$t('contractApplyAuditHistoryOrders.contractType')" align="center" width="130" />
        <el-table-column prop="stateName" :label="$t('contractApplyAuditHistoryOrders.contractStatus')" align="center" width="120">
          <template slot-scope="scope">
            <ds-status-tag :label="scope.row.stateName" :text="scope.row.stateName" type="info" />
          </template>
        </el-table-column>
        <el-table-column prop="signingTime" :label="$t('contractApplyAuditHistoryOrders.createTime')" align="center" width="160">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.signingTime || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('contractApplyAuditHistoryOrders.operation')" align="center" width="130" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="_openDetailPurchaseApplyModel(scope.row)">
              {{ $t('contractApplyAuditHistoryOrders.view') }}
            </el-button>
          </template>
        </el-table-column>
      </ds-data-table>

      <ds-pagination-bar :total="page.total" :page="page.current" :size="page.size"
        :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <!-- <audit-component ref="auditComponent" @notifyAudit="_auditOrderInfo" /> -->
  </div>
</template>

<script>
import { queryContractHistoryTask } from '@/api/contract/contractApplyAuditHistoryOrdersApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'ContractApplyAuditHistoryOrdersList',
  components: {
    DsPageHeader,
    DsToolbar,
    DsDataTable,
    DsPaginationBar,
    DsStatusTag
  },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      contractApplyAuditOrdersInfo: {
        contractApplyAuditOrders: [],
        conditions: {
          AuditOrdersId: '',
          userName: '',
          auditLink: ''
        }
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this._listAuditOrders(this.page.current, this.page.size)
  },
  methods: {
    async _listAuditOrders(page, size) {
      try {
        this.loading = true
        this.hasError = false
        this.errorMessage = ''
        const params = {
          page,
          row: size,
          ...this.contractApplyAuditOrdersInfo.conditions
        }
        const { data, total } = await queryContractHistoryTask(params)
        this.contractApplyAuditOrdersInfo.contractApplyAuditOrders = Array.isArray(data) ? data : []
        this.page.total = total || 0
      } catch (error) {
        console.error('获取合同历史订单失败:', error)
        this.hasError = true
        this.errorMessage = error.message || this.$t('contractApplyAuditHistoryOrders.page.loadFailed')
      } finally {
        this.loading = false
      }
    },
    _openDetailPurchaseApplyModel(auditOrder) {
      this.$router.push({
        path: '/pages/common/contractApplyDetail',
        query: { contractId: auditOrder.contractId }
      })
    },
    _openAuditOrderModel(auditOrder) {
      this.contractApplyAuditOrdersInfo.orderInfo = auditOrder
      this.$refs.auditComponent.open()
    },
    _auditOrderInfo(auditInfo) {
      console.log(auditInfo)
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this._listAuditOrders(this.page.current, val)
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listAuditOrders(val, this.page.size)
    }
  }
}
</script>

<style lang="scss" scoped>
.contract-apply-audit-history-orders-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}
</style>
